import axios from 'axios';

import { sendPasswordUpdateEmailUrl } from '../api-urls';

const createPasswordRetrievalRequest = email => ({
  url: sendPasswordUpdateEmailUrl,
  method: 'post',
  data: {
    login: email
  }
});

export default async email => {
  try {
    const request = createPasswordRetrievalRequest(email);
    const response = await axios(request);
    return response;
  } catch (err) {
    console.error('Erro ao recuperar senha', err);
    return Promise.reject(err.response.status);
  }
};
